/**
 * Resize/compress remote cover images (Unsplash, Pexels) for card thumbnails.
 */
import { resolveMediaUrl } from "./mediaUrl";

export function optimizeImageUrl(url, width = 640) {
  if (!url) return url;

  if (url.startsWith("/uploads") || url.includes("/uploads/")) {
    return resolveMediaUrl(url);
  }

  try {
    const parsed = new URL(url, "https://placeholder.local");

    if (parsed.hostname === "images.unsplash.com") {
      parsed.searchParams.set("w", String(width));
      parsed.searchParams.set("q", "80");
      parsed.searchParams.set("auto", "format");
      parsed.searchParams.set("fit", "crop");
      return parsed.toString();
    }

    if (parsed.hostname === "images.pexels.com") {
      parsed.searchParams.set("auto", "compress");
      parsed.searchParams.set("cs", "tinysrgb");
      parsed.searchParams.set("w", String(width));
      return parsed.toString();
    }
  } catch {
    return url;
  }

  return url;
}

export const CARD_IMAGE_WIDTH = 640;
export const CARD_IMAGE_WIDTH_2X = 960;
export const HERO_PAGE_WIDTH = 1280;
